import { render } from "./EditProduct.vue?vue&type=template&id=74ee89ec&scoped=true&ts=true"
import script from "./EditProduct.vue?vue&type=script&lang=ts"
export * from "./EditProduct.vue?vue&type=script&lang=ts"

import "./EditProduct.vue?vue&type=style&index=0&id=74ee89ec&lang=css"
import "./EditProduct.vue?vue&type=style&index=1&id=74ee89ec&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ee89ec"]])

export default __exports__